import { render, staticRenderFns } from "./AssessmentsGraph31.vue?vue&type=template&id=889c54b2"
import script from "./AssessmentsGraph31.vue?vue&type=script&lang=js"
export * from "./AssessmentsGraph31.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports